import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eac92d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "postionfixdiv" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_menu = _resolveComponent("n-menu")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"min-height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, {
        class: "banner",
        collapsed: $data.collapsed,
        "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => (($data.collapsed) = $event)),
        collapsible: ""
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_n_menu, {
            mode: "horizontal",
            options: $data.menuOptions
          }, null, 8, ["options"])
        ]),
        _: 1
      }, 8, ["collapsed"]),
      _hoisted_2,
      _createVNode(_component_a_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_footer, null, {
        default: _withCtx(() => [
          _createTextVNode(" © 2023 Baotool Project. All Rights Reserved. ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}